import React, { useEffect, useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Modal } from 'antd';
import { mixGetV1, mixDate } from "services/mixin";
import BillingPDF from "./BillingPDF";

interface Props {
    user: any
}
const Billing: React.FC<Props> = (prop) => {
    const [customerId, setCustomerId] = useState(null)
    const [listOrder, setListOrder] = useState([])
    const [orderDetail, setOrderDetail] = useState({})
    useEffect(()=> {
        setCustomerId(prop?.user?.id)
    },[prop])

    const getListOrder = async (id:any) => {
        const res = await mixGetV1(`/api/v1/fe/orders?sort[]=created_at,desc&customer_id=${id}`)

        if(res.status) {
            const items = res.data.items.map((order:any) => ({
                ...order,
                package: {
                    ...order.package,
                    content: order.package?.content ? JSON.parse(order.package.content) : null
                }
            }))
            setListOrder(items)
        } else {
            console.log(res.error)
        }
    } 

    const getOderDetail = async (id:any) => {
        try {
            // const res = await mixGetV1(`/api/v1/fe/order/${id}`)
            // if(res.status) {
            //     // const order = res.data.map((item:any) =>({
            //     //     ...item,
            //     //     package:{
            //     //         ...item.package,
            //     //         content: item.package.content ? JSON.parse(item.package.content) : null
            //     //     }
            //     // }))
            //     const order = {
            //         ...res.data,
            //         package:{
            //             ...res.data.package,
            //             content: res.data.package.content ? JSON.parse(res.data.package.content) : null
            //         }
            //     }
            //     setOrderDetail(order)
            // }
            const order = listOrder.find((item: any) => item.id === id);
            setOrderDetail(order || {})
        } catch (err) {
            console.log(err)
        }
    }

    // useEffect(() => {
    //     console.log(orderDetail)
    // },[orderDetail])
    useEffect(() => {
        getListOrder(customerId)
    },[customerId])

    const [isModalBillOpen, setIsModalBillOpen] = useState(false);

    const showModal = (id:any) => {
        setIsModalBillOpen(true);
        getOderDetail(id)
    };

    const handleCancel = () => {
        setIsModalBillOpen(false);
    };


   

    const [columns] = useState(["Order", "Date", "Invoice"]);

    // const [rows] = useState([
    //     { Order: "Premium Plan", Date: "10/08/2022" },
    //     { Order: "Free Trial", Date: "10/05/2022" },
    // ]);

    const rows = listOrder.map(order => ({
        id: order?.id,
        fileName: order?.code,
        Order: order?.package?.content?.val1,
        Date: order?.created_at,
    })) || []
    
    return (
        <section className="card" id="billing">
            <div className="card-header">
                <div className="title-card">Billing</div>
            </div>
            <div className="card-detail">
                <table>
                    <thead>
                        <tr>
                            {columns.map((col, index) => (
                                <th
                                    key={index}
                                >
                                    {col}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(row => (
                            <tr key={row.id}>
                                <td>
                                    {row.Order}
                                </td>
                                <td>
                                    {mixDate(row.Date, { hour: false })}
                                </td>
                                <td>
                                    <span onClick={() => showModal(row.id)} className="link">View</span>
                                    <span> | </span>
                                    <PDFDownloadLink
                                       document={<BillingPDF orderDetail={listOrder.find(o => o.id === row.id)} />}
                                        fileName={`${row.fileName}.pdf`}
                                    >
                                        <span className="link">Download</span>
                                    </PDFDownloadLink>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Modal
                title={null}
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalBillOpen}
                onCancel={handleCancel}
                footer={null}
                width={700}
                className="bill-modal"
            >
                { orderDetail ? (
                    <>
                        <div className="custom-modal-header">
                            <div className="left flex gap-3 items-center">
                                <img
                                    className="h-auto group-[.navbar-shrinked]/body:hidden dark:hidden"
                                    style={{ width: '100px' }}
                                    src="/magicAI-logo (1).svg"
                                    alt="SharAI - AI for the World"
                                />
                                <p>{orderDetail?.package?.content?.val1}</p>
                            </div>
                            <div className="right">
                                Invoice
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="info-bill">
                                {/* <div className="col">
                                    <div className="item">
                                        <p className="titlev1">Service Provider</p>
                                        <p style={{ fontWeight: 500 }}>Project Design Co.Ltd</p>
                                        <p>33 Nguyen Nguyen Thi Huynh Ward 8, District Phu Nhuan, Ho Chi Minh City, VietNam</p>
                                    </div>
                                </div> */}
                                <div className="col">
                                    <div className="item">
                                        <p className="titlev1">Customer</p>
                                        <p>{ orderDetail?.customer?.fullname }</p>
                                    </div>
                                    <div className="item">
                                        <p className="titlev1">Account</p>
                                        <p>{ orderDetail?.customer?.email }</p>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="item">
                                        <p className="titlev1">Invoice Number</p>
                                        <p>{ orderDetail?.code }</p>
                                    </div>
                                    <div className="item">
                                        <p className="titlev1">Date Issued</p>
                                        <p>{mixDate(orderDetail?.created_at, { hour: false })}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="detail-bill">
                                <div className="flex justify-between">
                                    <p>Membership Plan</p>
                                    <p>{orderDetail?.package?.content?.val1}</p>
                                </div>
                                <div className="flex justify-between">
                                    <p>Duration</p>
                                    <p>{ orderDetail?.package?.is_lifetime === 1 ? 'Lifetime': `${orderDetail?.package?.day} days` }</p>
                                </div>
                                <div className="flex justify-between total">
                                    <p>Amount</p>
                                    <p>${orderDetail?.total} USD</p>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <p>Loading...</p>
                ) }
            </Modal>
        </section>
    )
}
export default Billing